import { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Chefmate() {
   

    return (
        <>
            <Header />
            <div class="ai-ifm-div">
                <div class="ai-ifm-div-sub">
                <iframe src="https://chef.nugenesisou.com/"  height="800" class="relative w-full overflow-hidden" allow="fullscreen; clipboard-write; autoplay" ></iframe>
                </div>
            </div>
            <Footer />
        </>
    );
}
